import { registerPlugin } from '@capacitor/core';

import { type ShopflowPlugin, EVENTS, PLUGIN_EVENTS } from './definitions';
import { useReadRfid } from './useReadRfid';
import { usePowerRfid } from './usePowerRfid';
import { useKeyEvent } from './useKeyEvent';
import { useDeviceInfo } from './useDeviceInfo';
import { useWriteRfid } from './useWriteRfid';
import { useBattery } from './useBattery';
import { useBarcode } from './useBarcode';
import { useSound, SOUNDS } from './useSound';
import { useSearchUHF } from './useSearchUHF';
import { useUserAgent } from './ShopflowUserAgent';
import { useDeviceInfo_v2 } from './ShopflowDeviceInfo';

const Shopflow = registerPlugin<ShopflowPlugin>('Shopflow', {
  web: () => import('./ShopflowWeb').then((m) => new m.ShopflowWeb()),
});

export * from './definitions';
export {
  Shopflow,
  EVENTS,
  PLUGIN_EVENTS,
  SOUNDS,
  useReadRfid,
  usePowerRfid,
  useKeyEvent,
  useDeviceInfo,
  useWriteRfid,
  useBattery,
  useBarcode,
  useSound,
  useSearchUHF,
  useUserAgent,
  useDeviceInfo_v2,
};
